import React from 'react';
import { Box, Container, Grid, Typography, Link as MuiLink, useTheme } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';

const Footer = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const location = useLocation();
  // Extract language from the current URL path
  const match = location.pathname.match(/^\/(en|fr)(\/|$)/);
  const currentLang = match ? match[1] : 'en';

  // Function to generate language-aware links
  const getLanguagePath = (path) => {
    return `/${currentLang}${path}`;
  };
  
  return (
    <Box 
      component="footer" 
      sx={{ 
        py: 6, 
        mt: 'auto',
        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.2)' : 'rgba(0, 0, 0, 0.03)',
      }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={{ xs: 3, md: 4 }}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ fontWeight: 800, mb: 2 }}>
              {t('footer.digisparkFoundation')}
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              {t('footer.description')}
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <MuiLink 
                href="#" 
                color="inherit" 
                sx={{ 
                  display: 'flex',
                  p: 1,
                  borderRadius: 1,
                  '&:hover': {
                    backgroundColor: theme.palette.mode === 'dark' 
                      ? 'rgba(255, 255, 255, 0.08)' 
                      : 'rgba(0, 0, 0, 0.04)'
                  }
                }}
              >
                <FacebookIcon />
              </MuiLink>
              <MuiLink 
                href="#" 
                color="inherit" 
                sx={{ 
                  display: 'flex',
                  p: 1,
                  borderRadius: 1,
                  '&:hover': {
                    backgroundColor: theme.palette.mode === 'dark' 
                      ? 'rgba(255, 255, 255, 0.08)' 
                      : 'rgba(0, 0, 0, 0.04)'
                  }
                }}
              >
                <TwitterIcon />
              </MuiLink>
              <MuiLink 
                href="#" 
                color="inherit" 
                sx={{ 
                  display: 'flex',
                  p: 1,
                  borderRadius: 1,
                  '&:hover': {
                    backgroundColor: theme.palette.mode === 'dark' 
                      ? 'rgba(255, 255, 255, 0.08)' 
                      : 'rgba(0, 0, 0, 0.04)'
                  }
                }}
              >
                <InstagramIcon />
              </MuiLink>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
              {t('footer.quickLinks')}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <MuiLink component={Link} to={getLanguagePath('/')} color="inherit" underline="hover" sx={{ mb: 1 }}>{t('navbar.home')}</MuiLink>
              <MuiLink component={Link} to={getLanguagePath('/about')} color="inherit" underline="hover" sx={{ mb: 1 }}>{t('footer.about')}</MuiLink>
              <MuiLink component={Link} to={getLanguagePath('/programs')} color="inherit" underline="hover" sx={{ mb: 1 }}>{t('footer.programs')}</MuiLink>
              <MuiLink component={Link} to={getLanguagePath('/contact')} color="inherit" underline="hover">{t('footer.contact')}</MuiLink>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
              {t('navbar.getInvolved')}
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              info@digisparkfoundation.org
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <MuiLink component={Link} to={getLanguagePath('/donate')} color="inherit" underline="hover" sx={{ mb: 1 }}>{t('footer.donate')}</MuiLink>
              <MuiLink component={Link} to={getLanguagePath('/contact')} color="inherit" underline="hover">{t('contact.title')}</MuiLink>
            </Box>
          </Grid>
        </Grid>
        
        <Typography variant="body2" align="center" sx={{ mt: 4, pt: 4, borderTop: `1px solid ${theme.palette.divider}` }}>
          © {new Date().getFullYear()} {t('footer.digisparkFoundation')}. {t('footer.allRightsReserved')}
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer; 